import {
  DEFAULT_RETURNING_ITEMS_FROM_TITLE,
  DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE,
} from "@redotech/redo-customer-portal-shared/address-copy";
import { AddressInfo } from "@redotech/redo-customer-portal-shared/hooks/useAddress/use-address";
import { ReturnAddressType } from "@redotech/redo-customer-portal-shared/navigator";
import { useTranslation } from "@redotech/redo-i18n";
import { Address as AddressType } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { Address, AddressOld, AddressValidationStatus } from "./address";

export interface AddressesProps {
  addresses: AddressInfo[];
  onAddressSelected?: (type: AddressInfo["type"], address: AddressType) => void;
  onValidationStatusChanged?: (status: AddressValidationStatus) => void;
  continueDisabled?: boolean;
  showBorder?: boolean;
  skipComparison?: boolean;
}

export function Addresses({
  addresses,
  onAddressSelected,
  onValidationStatusChanged,
  continueDisabled = false,
  showBorder = true,
  skipComparison = false,
}: AddressesProps) {
  return (
    <Flex dir="column" gap="lg">
      {addresses.map((addressInfo) => (
        <Address
          addressInfo={addressInfo}
          continueDisabled={continueDisabled}
          key={addressInfo.type}
          onAddressSelected={onAddressSelected}
          onValidationStatusChanged={onValidationStatusChanged}
          showBorder={showBorder}
          skipComparison={skipComparison}
        />
      ))}
    </Flex>
  );
}

export const AddressesOld = memo(function Addresses({
  shippingAddress,
  newOrderAddress,
  hasNonGreenReturnItems,
  showNewItems,
  showNewOrderAddress,
  edit,
  direction = "column",
}: {
  shippingAddress: AddressType | null | undefined;
  newOrderAddress: AddressType | null | undefined;
  hasNonGreenReturnItems: boolean;
  showNewItems: boolean;
  showNewOrderAddress: boolean;
  edit?: (type: ReturnAddressType) => void;
  direction?: "column" | "row";
}) {
  const { t } = useTranslation();
  return (
    <Flex flexDirection={direction} gap="xl">
      {shippingAddress && (hasNonGreenReturnItems || showNewItems) && (
        <AddressOld
          address={shippingAddress}
          edit={edit ? () => edit(ReturnAddressType.SHIPPING) : undefined}
          title={
            hasNonGreenReturnItems
              ? t(DEFAULT_RETURNING_ITEMS_FROM_TITLE)
              : t(DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE)
          }
        />
      )}
      {hasNonGreenReturnItems && showNewOrderAddress && (
        <AddressOld
          address={newOrderAddress ?? undefined}
          edit={edit ? () => edit(ReturnAddressType.NEW_ORDER) : undefined}
          title={t(DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE)}
        />
      )}
    </Flex>
  );
});
